const consolidatedTrendAnalysisResource = (() => {
	const _default_config = {
		width: {
			chart1: 0
		}
	};
	const init = (default_config, resource, resource_config) => {
		Object.assign(_default_config, default_config);
		Object.assign(_default_config, resource_config);
		_default_config.resource = resource;
		_default_config.last_selected_account_number_option = _default_config._default_option;
		_default_config.maped_data = new Map();
		_default_config.old_data = _default_config.data;
		_default_config.maped_data[_default_config._default_option] = updateData(_default_config.data[0]);
		_default_config.headers = Object.keys(_default_config.maped_data[_default_config._default_option][0]);
		
		for (let i = 0; i < _default_config.headers.length; ++i) if (!_default_config.body.config[resource].columns[_default_config.headers[i]]) _default_config.body.config[resource].columns[_default_config.headers[i]] = _default_config["_" + resource]._default_option_config;
		for (let i = 0; i < _default_config.account_level.length; ++i) _default_config.maped_data[templateEvents.stringMasking(_default_config.account_level[i].account_number)] = updateData(_default_config.account_level[i]);
		appendHTML();
		templateEvents.updatedOnWindowResize(loadChartMiddle);
	};

	function updateData(data_arr) {
		const rowHeads = {"revenue":"Revenue", "expense":"Operating Expense", "debt": "Debt Service"}
		const resp = {}, resp_data = [], keys = ["revenue", "expense", "debt"];
		_default_config.select1 = _default_config.select2 = keys;
		let data = data_arr.summary;
		for (let i = 0; i < data.length; ++i) {
			for (let j = 0; j < keys.length; ++j) {
				if (!!!resp[keys[j]]) resp[keys[j]] = { "group": initScript.keyToCamelCaseWithUpperCaseString(keys[j]), "total": 0, "group_name": initScript.keyToCamelCaseWithUpperCaseString(rowHeads[keys[j]]) };
				resp[keys[j]][data[i].month_year] = data[i][keys[j]];
			}
		}
		for (let i = 0; i < keys.length; ++i) {
			resp[keys[i]].total = data_arr["total_amount_by_category"][keys[i]];
			resp_data.push(resp[keys[i]]);
		}
		return resp_data;
	}
	const getHeading = (selected_val, num) => {
		return "Variable " + num + " : " + initScript.keyToCamelCaseWithUpperCaseString(selected_val);
	};

	/**
	 * getDescription : appending html
	 *
	 * @author Nitesh <nitesh.meena@biz2credit.com>
	 *
	 * @param selected_val
	 */

	const getDescription = selected_val => {
		return "Last 12 Months" + initScript.keyToCamelCaseWithUpperCaseString(selected_val) + " / " + "Annualized " + initScript.keyToCamelCaseWithUpperCaseString(selected_val);
	};

	/**
	 * appendHTML : appending html
	 *
	 * @author Nitesh <nitesh.meena@biz2credit.com>
	 *
	 */

	const appendHTML = () => {
		appendTableHeaders();
		populateConsolidatedData();
	};

	/**
	 * loadChart : loading chart
	 *
	 * @author Nitesh <nitesh.meena@biz2credit.com>
	 *
	 */

	const loadChart = (data) => {
		const chart_config = _default_config.charts[_default_config.resource];
		const dd = initScript.getHTMLElementByDelimiter("monthly-summery").height() + (initScript.getHTMLElementObject("header").length ? (30 - 10 + initScript.getHTMLElementObject("header").height()) : 0) + (initScript.getHTMLElementByDelimiter("mainnav").length ? initScript.getHTMLElementByDelimiter("mainnav").height() : 0);
		Object.assign(chart_config, {
			"width": _default_config.width.chart1,
			"margin": _default_config.width.chart1 * 0.045,
			"tooltip": {
				"diff": true,
				"top": dd,
				"left": +(window.innerWidth - initScript.getHTMLElementByDelimiter("trend-analysis-graph").width()) / 2,
			},
			"color": (_default_config.is_left_card_on && _default_config.is_right_card_on) ? ["#178CDC", "#00CB96"] : _default_config.is_left_card_on ? ["#178CDC"] : ["#00CB96"],
			"resource": _default_config.resource,
			"data": data
		});
		charts.line.init(chart_config);
		analyserV2.resolvePromise();
	};

	const loadBar = (data) => {
		var headLabels = {"revenue":"Revenue", "expense":"Operating Expense", "debt": "Debt Service"};
		document.getElementById("graph_variable1").innerHTML =  "";
		document.getElementById("heading_variable1").innerHTML = headLabels[_default_config.last_selected_variable1_option];
		const dd = initScript.getHTMLElementByDelimiter(_default_config.body.class + " .monthly-summery").height() + (initScript.getHTMLElementObject("header").length ? (30 + initScript.getHTMLElementObject("header").height()) : 0) + (initScript.getHTMLElementByDelimiter("mainnav").length ? initScript.getHTMLElementByDelimiter("mainnav").height() : 0);
		var barConfig = {
			"x_axis": "model_name",
			"barWidth": 1,
			"height": 320,
			"margin": { "top": 20, "right": 10, "bottom": 20, "left": 50 },
			"bar_padding": 0.5,
			"bar_margin": 10,
			"axis_ticks": { "qty": 12, "outer_size": 0 },
			"color": { "bars": { "field1": "#158cdc"} },

			"max_y_axis": 0,
			"id": "#graph_variable1",
			"width": 500, //checkout
			"data": [],
			"is_doller_format": true,
			"tooltip": {
				"top": dd-30, //checkout
				"left": -42,
				"diff_class": "graph",
			}
		};
		//Load variable 1 graph
		var gdata = [], variable1 = data.filter(e => e.name == "Variable 1");
		if(_default_config.is_left_card_on || variable1.length > 0){
			for (const v of variable1[0].values) {
				var xaxis = new Date(v.date+"-1")
				xaxis = _default_config.months[xaxis.getMonth()]+"-"+xaxis.getFullYear()
				gdata.push({ "model_name": xaxis, "field1": Math.abs(parseFloat(v.price)), "field1_is_neg": (parseFloat(v.price) < 0)});
				barConfig.max_y_axis = (barConfig.max_y_axis > Math.abs(parseFloat(v.price)))?barConfig.max_y_axis:Math.abs(parseFloat(v.price));
			}
		}
		barConfig.data = gdata;
		charts.bar.init(barConfig);
		
		//Load Variable 2 graph
		barConfig.max_y_axis = 0;
		document.getElementById("graph_variable2").innerHTML =  "";
		document.getElementById("heading_variable2").innerHTML = headLabels[_default_config.last_selected_variable2_option];
		barConfig.id = "#graph_variable2";
		var gdata = [], variable2 = data.filter(e => e.name == "Variable 2")
		if(_default_config.is_right_card_on || variable2.length > 0){
			for (const v of variable2[0].values) {
				var xaxis = new Date(v.date+"-1")
				xaxis = _default_config.months[xaxis.getMonth()]+"-"+xaxis.getFullYear()
				gdata.push({ "model_name": xaxis, "field1": Math.abs(parseFloat(v.price)), "field1_is_neg": (parseFloat(v.price) < 0)});
				barConfig.max_y_axis = (barConfig.max_y_axis > Math.abs(parseFloat(v.price)))?barConfig.max_y_axis:Math.abs(parseFloat(v.price));
			}
		}
		barConfig.data = gdata;
		barConfig["color"]["bars"]["field1"] = "#14d899",
		charts.bar.init(barConfig);
		analyserV2.resolvePromise();
	}

	/**
	 * appendTableHeaders : appending html
	 *
	 * @author Nitesh <nitesh.meena@biz2credit.com>
	 *
	 */

	const appendTableHeaders = () => {
		let headers = _default_config.headers, mid_panel_headers = initScript.removeUnexpectedElements(headers, ["group", "total", "group_name"]);
		_default_config.month = mid_panel_headers;
		_default_config.table_divs = _default_config.table_divs[_default_config.resource];
		_default_config.table_divs[1].columns = mid_panel_headers;
	};

	/**
	 * filterData : filtering data
	 *
	 * @author Nitesh <nitesh.meena@biz2credit.com>
	 *
	 */

	const filterData = () => {
		let filter_options = _default_config.filter || {};
		filter_options = Object.keys(filter_options);
		for (let i = 0; i < filter_options.length; ++i) {
			const html_config = [];
			let options = [];
			if (filter_options[i] === "account_number") options = _default_config[filter_options[i]].length > 1 ? [_default_config._default_option].concat(_default_config[filter_options[i]]) : _default_config[filter_options[i]];
			else if (filter_options[i] === "select1") options = ["Revenue", "Expense", "Debt"];
			else options = ["Expense", "Debt", "Revenue"];
			let option_representation = {"Revenue": "Revenue", "Expense": "Operating Expense", "Debt": "Debt Service"}
			for (let j = 0; j < options.length; ++j) {
				let option_label = "";
				if(undefined === option_representation[options[j]]){
					option_label = (options[j] === _default_config._default_option) ? (initScript.getObjectValue(_default_config, "body.config." + _default_config.resource + ".filter." + filter_options[i] + ".default_option") || options[j]) : options[j]
				}
				else{
					option_label = option_representation[options[j]];
				}
				
				html_config.push({
					"html":option_label,
					"config": {
						"value": options[j]
					}
				});
			}
			// console.log(html_config);
			initScript.getHTMLElementByDelimiter(initScript.keyToCamelCaseString(filter_options[i] + "_" + _default_config.resource + "_filter")).html(initScript.getCommonHTML(html_config, "option"));
		}
	};

	/**
	 * populateConsolidatedData : showing consolidated html
	 *
	 * @author Nitesh <nitesh.meena@biz2credit.com>
	 *
	 */

	function populateConsolidatedData() {
		_default_config["consolidated"] = _default_config.data;
		_default_config.account_number = templateEvents.maskingUtility(_default_config.data[0].account_number);
		_default_config.data = _default_config.maped_data[_default_config._default_option];
		templateUtil.appendTabelHeaders(_default_config);
		templateUtil.appendTabelRows(_default_config);
		_default_config.width.chart1 = initScript.getHTMLElementByDelimiter(_default_config.body.class + " ." + _default_config.trend_analysis_graph.class).width();
		filterData();
		loadChartMiddle();
		updateComparisionFilter();
		comparisionEvent();
	}

	/**
	 * updateComparisionFilter : extracting data
	 *
	 * @author Nitesh <nitesh.meena@biz2credit.com>
	 *
	 */

	function updateComparisionFilter() {
		_default_config.comparision_filter = {};
		for (let i = 0; i < _default_config.account_level.length; ++i)  _default_config.comparision_filter[templateEvents.stringMasking(_default_config.account_level[i].account_number)] = _default_config.account_level[i]["aggregated_percentage"]
		_default_config.comparision_filter[_default_config._default_option] = _default_config.old_data[0]["aggregated_percentage"]
	}

	/**
	 * refreshHTML : showing consolidated html
	 *
	 * @author Nitesh <nitesh.meena@biz2credit.com>
	 *
	 */

	function refreshHTML() {
		_default_config.data = _default_config.maped_data[_default_config.last_selected_account_number_option];
		_default_config.headers = Object.keys(_default_config.maped_data[_default_config.last_selected_account_number_option][0]);
		var resource = _default_config.resource;
		for (let i = 0; i < _default_config.headers.length; ++i) if (!_default_config.body.config[resource].columns[_default_config.headers[i]]) _default_config.body.config[resource].columns[_default_config.headers[i]] = _default_config["_" + resource]._default_option_config;

		let headers = _default_config.headers, mid_panel_headers = initScript.removeUnexpectedElements(headers, ["group", "total", "group_name"]);
		_default_config.month = mid_panel_headers;
		_default_config.table_divs[1].columns = mid_panel_headers;
		$(".midPanelDataHeadConsolidatedTrendAnalysis").html("")
		templateUtil.appendTabelHeaders(_default_config);
		templateUtil.appendTabelRows(_default_config);
		loadChartMiddle();
		comparisionEvent();
	}

	/**
	 * getAccountNumberConsolidatedTrendAnalysisSelectedValue : returning selected value
	 *
	 * @author Nitesh <nitesh.meena@biz2credit.com>
	 *
	 * @param event object
	 */

	function getAccountNumberConsolidatedTrendAnalysisSelectedValue(event) {
		const selected_val = event.target.value.trim();
		if (_default_config.last_selected_account_number_option === selected_val) return;
		_default_config.last_selected_account_number_option = selected_val;
		refreshHTML(selected_val);
	}
	/**
	 * select1ConsolidatedTrendAnalysisSelectedValue : returning selected value
	 *
	 * @author Nitesh <nitesh.meena@biz2credit.com>
	 *
	 * @param event object
	 */

	function select1ConsolidatedTrendAnalysisSelectedValue(event) {
		const selected_val = event.target.value.trim().toLowerCase();
		if (_default_config.last_selected_variable1_option === selected_val) return;
		_default_config.last_selected_variable1_option = selected_val;
		loadChartMiddle();
		comparisionEvent();
	}

	/**
	 * select2ConsolidatedTrendAnalysisSelectedValue : returning selected value
	 *
	 * @author Nitesh <nitesh.meena@biz2credit.com>
	 *
	 * @param event object
	 */

	function select2ConsolidatedTrendAnalysisSelectedValue(event) {
		const selected_val = event.target.value.trim().toLowerCase();
		if (_default_config.last_selected_variable2_option === selected_val) return;
		_default_config.last_selected_variable2_option = selected_val;
		loadChartMiddle();
		comparisionEvent();
	}

	/**
	   * clearElements : clearing html
	   *
	   * @author Nitesh <nitesh.meena@biz2credit.com>
	   *
	   */

	function clearElements() {
		initScript.innerHTMLToATarget(initScript.getHTMLElementByDelimiter(_default_config.trend_analysis_graph.class), "");
	}

	function loadChartMiddle() {
		clearElements();
		const data = [];
		if (_default_config.is_left_card_on) data.push({
			name: "Variable 1",
			values: selectedResourceData(_default_config.last_selected_variable1_option)
		});
		if (_default_config.is_right_card_on) data.push({
			name: "Variable 2",
			values: selectedResourceData(_default_config.last_selected_variable2_option, "right")
		});
		// if (data.length) loadChart(data); //Line chart
		loadBar(data);
	}

	/**
	 * selectedResourceData : returning selected resource data
	 *
	 * @author Nitesh <nitesh.meena@biz2credit.com>
	 *
	 * @param selected_val string
	 * @param from
	 */

	function selectedResourceData(selected_val, from = "left") {
		const resp = [], data = _default_config.maped_data[_default_config.last_selected_account_number_option];
		for (let i = 0; i < data.length; ++i) {
			if (data[i].group.trim().toLowerCase() === selected_val) {
				for (let j = 0; j < _default_config.month.length; ++j) {
					resp.push({
						date: templateEvents.dateToYearMonthFormat(_default_config.month[j]),
						price: data[i][_default_config.month[j]],
						from: from,
					});
				}
			}
		}
		return resp;
	}

	/**
	 * comparisionEvent : displaying hovered circle value
	 *
	 * @author Nitesh <nitesh.meena@biz2credit.com>
	 *
	 */

	function comparisionEvent() {
		let option_representation = {"Revenue": "Revenue", "Expense": "Operating Expense", "Debt": "Debt Service"}
		let account_number = _default_config.last_selected_account_number_option,
			filter_option_1 = _default_config.last_selected_variable1_option,
			filter_option_2 = _default_config.last_selected_variable2_option;
		document.getElementById("left-percent").innerHTML = _default_config.comparision_filter[account_number]["percentage_" + filter_option_1] + "%";
		document.getElementById("right-percent").innerHTML = _default_config.comparision_filter[account_number]["percentage_" + filter_option_2] + "%";

		filter_option_1 = initScript.keyToCamelCaseWithUpperCaseString(filter_option_1);
		filter_option_2 = initScript.keyToCamelCaseWithUpperCaseString(filter_option_2);

		document.getElementById("left-heading").innerHTML = "Variable 1 : " + option_representation[filter_option_1];
		document.getElementById("right-heading").innerHTML = "Variable 2 : " + option_representation[filter_option_2];

		document.getElementById("left-description").innerHTML = "Last 2 Months " + option_representation[filter_option_1] + " / Annualized " + option_representation[filter_option_1];
		document.getElementById("right-description").innerHTML = "Last 2 Months " + option_representation[filter_option_2] + " / Annualized " + option_representation[filter_option_2];
	}
	/**
	 * showVariableChart1 : displaying hovered circle value
	 *
	 * @author Nitesh <nitesh.meena@biz2credit.com>
	 *
	 * @param event object
	 */

	function showVariableChart1(event) {
		_default_config.is_left_card_on = event.target.checked;
		loadChartMiddle()
	}
	/**
	 * showVariableChart2 : displaying hovered circle value
	 *
	 * @author Nitesh <nitesh.meena@biz2credit.com>
	 *
	 * @param event object
	 */

	function showVariableChart2(event) {
		_default_config.is_right_card_on = event.target.checked;
		loadChartMiddle();
	}

	return {
		init,
		getAccountNumberConsolidatedTrendAnalysisSelectedValue,
		select1ConsolidatedTrendAnalysisSelectedValue,
		select2ConsolidatedTrendAnalysisSelectedValue,
		showVariableChart1,
		showVariableChart2
	};
})();
